import React from 'react'
import Navbar from '../../../../components/Navbar'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import Loaders from '../../../../components/Loaders';

export default function AddCoupon() {
    const [isCodeUnique, setIsCodeUnique] = useState(true);
    const [ambassadorsDetails, setAmbassadorsDetails] = useState({});
    const [code, setCode] = useState()
    const params = useParams();
    const axiosPrivate = useAxiosPrivate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const checkCodeUnique = async (value) => {
        try {
            setCode(value)
            const response = await axiosPrivate.post("coupon/check-unique", { "code": value });
            if (response.data.success === false) {
                return false;
            }
            return true;
        } catch (error) {

            console.error(error);
        }
    };
    const postData = async (data) => {
        const response = axiosPrivate.post('coupon/with-ambassador', {
            name: data.name,
            phone: data.phone,
            email: data.email,
            code: data.code,
            value: data.value,
            coupon_type: 'campaign',
            ambassador_percentage: data.ambassador_percentage
        });
        return response;
    }

    const { mutate } = useMutation(postData, {
        onSuccess: (successData) => {
            if (successData?.data?.success) {
                setTimeout(() => {
                    window.location.href = '/admin/dashboard/ambassadors'
                }, 3000)
            }
        }
    })

    const onSubmit = (data) => {
        mutate(data);
    }

    useEffect(() => {
        Object.keys(ambassadorsDetails).forEach((key) => {
            setValue(key, ambassadorsDetails[key]);
        });
    }, [ambassadorsDetails, setValue])

    const handleCodeBlur = async (event) => {
        const code = event.target.value;
        const isUnique = await checkCodeUnique(code);
        setIsCodeUnique(isUnique);
    };

    const handleAmbassadorsDetails = () => {
        const res = axiosPrivate.get(`/ambassador/details?ambassador_id=${params.id}`)
        return res;
    };

    const { isLoading, isError, error } = useQuery({
        queryKey: 'ambassadorsDetails',
        queryFn: handleAmbassadorsDetails,
        onSuccess: (data) => {
            setAmbassadorsDetails(data?.data?.data)
        }
    })
    return (
        <>
            <Navbar
                title={`Create a new Coupon For ${ambassadorsDetails?.name}`}
            />
            {
                isLoading ? <div className="d-flex justify-content-center align-items-center">
                    <Loaders />
                </div> : isError ? <div>{error}</div> : <div></div>
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='container my-5'>
                    <div className='card'>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    id="name"
                                    label="Name"
                                    variant="outlined"
                                    placeholder="Enter Ambassador Name"
                                    fullWidth={true}
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={true}
                                    {...register("name")}
                                    error={!!errors?.name}
                                    helperText={errors.name?.message}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="phone"
                                    label="Phone"
                                    variant="outlined"
                                    placeholder="Enter Phone Number"
                                    fullWidth={true}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={true}
                                    margin="normal"
                                    {...register("phone")}
                                    error={Boolean(errors?.phone)}
                                    helperText={errors.phone ? errors.phone?.message : ""}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="email"
                                    label="Email"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    placeholder="Enter Email"
                                    fullWidth={true}
                                    disabled={true}
                                    margin="normal"
                                    {...register("email")}
                                    error={Boolean(errors?.email)}
                                    helperText={errors.short_code ? errors.email?.message : ""}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="code"
                                    label="Code"
                                    variant="outlined"
                                    placeholder="Enter Code"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    fullWidth={true}
                                    {...register("code")}
                                    onBlur={handleCodeBlur} // <-- Add onBlur event handler
                                    error={!isCodeUnique} // <-- Set error state based on isCodeUnique
                                    helperText={code && (isCodeUnique === false ? <p>Code is NOT available</p> : <p className='text-success'>Code is available </p>)}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="value"
                                    label="Discount %"
                                    variant="outlined"
                                    placeholder="Enter Discount %"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    fullWidth={true}
                                    {...register("value")}
                                    error={Boolean(errors?.value)}
                                    helperText={errors.value ? errors.value?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="ambassador_percentage"
                                    label="Kickback %"
                                    variant="outlined"
                                    placeholder="Enter Kickback %"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    fullWidth={true}
                                    {...register("ambassador_percentage")}
                                    error={Boolean(errors?.ambassador_percentage)}
                                    helperText={errors.ambassador_percentage ? errors.ambassador_percentage?.message : ""}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <button
                                    className='btn btn-success text-white'
                                    type="submit"
                                    disabled={!isCodeUnique} // <-- Disable button if code is not unique
                                >Submit</button>

                            </Grid>
                        </Grid>


                    </div>

                </div>
            </form >

        </>

    )
}
